import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormioModule } from 'angular-formio';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormioModule } from 'angular-material-formio';
import { InlineSVGModule } from 'ng-inline-svg';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PartialsModule } from '../../partials/partials.module';
import { FormsTemplatesRoutingModule } from './forms-templates-routing.module';
import { formReducer } from './reducers/form.reducer';
import { templateReducer } from './reducers/template.reducer';
import { formTemplateMapReducer } from './reducers/form-template-map.reducer';
import { FormEffects, TemplateEffects, FormTemplateMapEffects } from './effects';
import { FormUtility } from './utils';
import {
  FormListComponent,
  CreateFormComponent,
  CreateFormSchemaComponent,
  TemplateListComponent,
  CreateTemplateComponent,
  CreateFormSynonymLinkComponent,
  FormTemplateMapListComponent,
  CreateFormTemplateMapComponent,
  FillFormComponent,
} from './components';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
  declarations: [
    FormListComponent,
    CreateFormComponent,
    CreateFormSchemaComponent,
    TemplateListComponent,
    CreateTemplateComponent,
    CreateFormSynonymLinkComponent,
    FormTemplateMapListComponent,
    CreateFormTemplateMapComponent,
    FillFormComponent,
  ],
  entryComponents: [
    CreateFormComponent,
    CreateFormSchemaComponent,
    CreateTemplateComponent,
    CreateFormSynonymLinkComponent,
    CreateFormTemplateMapComponent,
    FillFormComponent,
  ],
  imports: [
    FormsTemplatesRoutingModule,
    CommonModule,
    StoreModule.forFeature('form', formReducer),
    EffectsModule.forFeature([FormEffects]),
    StoreModule.forFeature('template', templateReducer),
    EffectsModule.forFeature([TemplateEffects]),
    StoreModule.forFeature('formTemplateMap', formTemplateMapReducer),
    EffectsModule.forFeature([FormTemplateMapEffects]),
    NgxPermissionsModule.forChild(),
    TranslateModule,
    ReactiveFormsModule,
    FormioModule,
    MatSortModule,
    MatPaginatorModule,
    MatFormioModule,
    InlineSVGModule,
    PerfectScrollbarModule,
    PartialsModule,
    MatMenuModule,
  ],
  exports: [FillFormComponent],
  providers: [
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
    FormUtility,
  ],
})
export class FormsTemplatesModule {}
